// import React, { useState } from 'react';
// import {Link} from 'react-router-dom';

import React, {useState, useEffect} from "react";

import axios from "axios";
import {Link} from 'react-router-dom';

import {useNavigate, NavLink, useLocation } from 'react-router-dom';

axios.defaults.baseURL='https://suvivah.org/suvivah/api/';


function Navbar() {

  const location = useLocation();

  const isLoginPage =
    location.pathname === "/login" ||
    location.pathname === "/forgotpassword";

  // const isRegisterActive = location.pathname === "/register";

  let navigate = useNavigate();

  // const [catlisting, setCatlisting] = useState([]);

  // async function getparentcat() {
  //     var resp=await axios.get("/getparentcat");
  //     var data=resp.data;
  //     setCatlisting(data);
  
  //  }

   
  useEffect(() => {

    // localStorage.removeItem('pid');

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });

    // getparentcat();
    
  }, [])


    return(
        <>        
       
     {/* 
     <nav className="navbar navbar-expand-lg navbar-light bg-blank sticky-top">
            <div className="container-fluid">
              <Link className="navbar-brand" to="/"><img src="../../images/logo.png" alt="" /></Link>
              <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <i className="fa fa-bars" aria-hidden="true"></i>
              </button>
              <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                  <li className="nav-item">
                    <Link className="nav-link active" aria-current="page" to="/">Home</Link>
                  </li>
                  <li className="nav-item"><Link className="nav-link" to="/about-us">About</Link></li>
                  <li className="nav-item dropdown">
                    <Link className="nav-link dropdown-toggle" to="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                      Our Products
                    </Link>


                    <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                    {catlisting.map((e)=>
                      <li key={e.cat_id}><Link className="dropdown-item" to={'/products/'+e.cat_name+ '/'+e.cat_id}>{e.cat_name}</Link></li>
                    )}
                      

                    </ul>


                  </li>
                  <li className="nav-item"><Link className="nav-link" to="/blog">Blog</Link></li>
                  <li className="nav-item"><Link className="nav-link" to="/gallery">Gallery</Link></li>
                  <li className="nav-item"><Link className="nav-link" to="/members">Members</Link></li>
                  <li className="nav-item"><Link className="nav-link btn-primary text-light rounded px-3" to="/contact-us">Contact Us</Link></li>
                </ul>
                
              </div>
            </div>
          </nav>
           */}

    <div className="bg_top"></div>

    <div className="d-none d-lg-block">
      {/* <div className="py-3 text-center logo">
          <Link to="/"><img src="images/logo.png" alt="" className="img-fluid" /></Link>
      </div> */}
    

      <nav className="navbar navbar-expand-lg navbar-light ">
        <div className="container">    
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <i className="fa fa-bars" aria-hidden="true"></i>
          </button>
          <div className="collapse navbar-collapse justify-content-center" id="navbarSupportedContent">

            <div className="py-3 text-center logo justify-content-center">
                <Link to="/"><img src="images/logo.png" alt="" className="img-fluid" /></Link>
            </div>

            <ul className="navbar-nav justify-content-center_ w-100 mb-2 ps-5 mb-lg-0">
              <li className="nav-item">
                <Link className="nav-link active" aria-current="page" to="/">Home</Link>
              </li>
              {/* <li className="nav-item">
                <Link className="nav-link" to="/about">About Us</Link>
              </li>   */}

              <li className="nav-item dropdown">
                <Link className="nav-link dropdown-toggle" to="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                About Us
                </Link>
                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li><Link className="dropdown-item" to="/mission-vision">Mission &amp; Vision</Link></li>
                  {/* <li><Link className="dropdown-item" to="/governing-body">Governing Body</Link></li> */}
                  {/* <li><Link className="dropdown-item" to="#">Action</Link></li>
                  <li><Link className="dropdown-item" to="#">Another action</Link></li> */}
                
                </ul>
              </li> 



              <li className="nav-item d-none">
                <Link className="nav-link" to="/success-story">Success Story</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/faqs">FAQs</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/contact-us">Contact Us</Link>
              </li>

                                        

          {/* <li className="nav-item dropdown">
                <Link className="nav-link dropdown-toggle" to="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                  Dropdown
                </Link>
                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li><Link className="dropdown-item" to="#">Action</Link></li>
                  <li><Link className="dropdown-item" to="#">Another action</Link></li>
                  <li><hr className="dropdown-divider"></li>
                  <li><Link className="dropdown-item" to="#">Something else here</Link></li>
                </ul>
              </li>  */}
            
            </ul>


            <div className="d-flex">
            
              {!localStorage.getItem("pid")?
              <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                {/* <Link className="nav-link btn-register" aria-current="page" to="/login"> */}
                <NavLink
                  to="/login"
                  className={({ isActive }) =>
                    `nav-link ${isActive || location.pathname === "/forgotpassword" ? "btn-register" : ""}`
                  }
                >
                  <span>Login</span>
                </NavLink>
              </li>
              <li className="nav-item">
                {/* <Link className="nav-link btn-register" to="/register"> */}
                <NavLink
                  to="/register"
                  className={`nav-link ${!isLoginPage ? "btn-register" : ""}`}
                >
                  <span>Register</span>
                </NavLink>
              </li>
              </ul>
              :
              <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                <li className="nav-item">
                <Link className="nav-link" aria-current="page" to="/dashboard">
                  {/* <i className="fa fa-tachometer me-2" aria-hidden="true"></i>  */}
                  Dashboard</Link>
              </li>
              <li className="nav-item">
                <button className="btn nav-link" aria-current="page" onClick={()=>{
                  // alert(localStorage.getItem("pid")+', '+localStorage.getItem("profile_id")+', '+localStorage.getItem("userregstep"));
                  localStorage.removeItem("pid");
                  localStorage.removeItem("profile_id");
                  localStorage.removeItem("userregstep");
                  
                  let path=`../login`;
                  navigate(path);
                }}>
                {/* <i className="fa fa-sign-out" aria-hidden="true"></i>    */}
                Logout</button>
              </li>
              
              </ul>
            }

                
            </div>
          </div>
        </div>
      </nav>
    </div>

    {/* Mobile Header */}
    <div className="d-lg-none">
        <div className="d-flex justify-content-between align-items-center px-3 py-2">
            <Link to="/">
                <img
                    src="images/logo.png"
                    alt="Logo"
                    className="img-fluid"
                    style={{ height: "80px" }}
                />
            </Link>

            <button
                className="btn border-0 p-0"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#mobileMenu"
            >
                <i className="fa fa-bars fs-custom-1"></i>
            </button>
        </div>

        {/* Drawer Menu */}
        <div
            className="offcanvas offcanvas-start"
            tabIndex="-1"
            id="mobileMenu"
            style={{ width: "80%" }}
        >
            <div className="offcanvas-header text-center pt-5 position-relative">
                <Link to="/">
                    <img src="images/logo.png" style={{width: '70%'}} classname="img-fluid" />
                </Link>

                <button
                  type="button"
                  className="btn btn-danger rounded-circle position-absolute top-0 end-0 m-2 d-flex align-items-center justify-content-center"
                  data-bs-dismiss="offcanvas"
                  style={{ width: "40px", height: "40px" }}
              >
                  <i className="fa fa-times text-white fs-1"></i>
              </button>
            </div>

            <div className="offcanvas-body">

                <ul className="navbar-nav fs-4">

                    <li className="nav-item">
                        <Link className="nav-link" to="/">Home</Link>
                    </li>

                    <li className="nav-item dropdown">
                        <a
                            className="nav-link dropdown-toggle"
                            href="#"
                            data-bs-toggle="dropdown"
                        >
                            About Us
                        </a>

                        <ul className="dropdown-menu">
                            <li>
                                <Link
                                    className="dropdown-item"
                                    to="/mission-vision"
                                >
                                    Mission & Vision
                                </Link>
                            </li>
                        </ul>
                    </li>

                    <li className="nav-item">
                        <Link className="nav-link" to="/success-story">
                            Success Story
                        </Link>
                    </li>

                    <li className="nav-item">
                        <Link className="nav-link" to="/faqs">
                            FAQs
                        </Link>
                    </li>

                    <li className="nav-item">
                        <Link className="nav-link" to="/contact-us">
                            Contact Us
                        </Link>
                    </li>

                    <hr />

                    {!localStorage.getItem("pid") ? (
                        <>
                            <li className="nav-item">
                                {/* <Link className="nav-link" to="/login">
                                    <i className="fa fa-user-o me-2"></i>
                                    Login
                                </Link> */}
                                <NavLink
                                  to="/login"
                                  className={({ isActive }) =>
                                    `nav-link ${isActive || location.pathname === "/forgotpassword" ? "btn-register" : ""}`
                                  }
                                >
                                  <span>Login</span>
                                </NavLink>
                            </li>

                            <li className="nav-item py-2">
                                {/* <Link
                                    className="nav-link btn-register"
                                    to="/register"
                                >
                                    <span>Register</span>
                                </Link> */}
                                <NavLink
                                  to="/register"
                                  className={`nav-link ${!isLoginPage ? "btn-register" : ""}`}
                                >
                                  <span>Register</span>
                                </NavLink>
                            </li>
                        </>
                    ) : (
                        <>
                            <li className="nav-item">
                                <Link className="nav-link" to="/dashboard">
                                    {/* <i className="fa fa-tachometer me-2"></i> */}
                                    Dashboard
                                </Link>
                            </li>

                            <li className="nav-item">
                                <button
                                    className="btn nav-link"
                                    onClick={() => {
                                        localStorage.removeItem("pid");
                                        localStorage.removeItem("profile_id");
                                        localStorage.removeItem("userregstep");
                                        navigate("/login");
                                    }}
                                >
                                    <i className="fa fa-sign-out me-2"></i>
                                    Logout
                                </button>
                            </li>
                        </>
                    )}

                </ul>
            </div>
        </div>
    </div>

   
        </>
    );
}

export default Navbar;